import { Form, Input, Switch, Row, Col, Select } from 'antd';
import { useRef, useState, useEffect } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import getList from '../../../utilsTsx/universal/getList';
import { getService } from '../../system/WebUniversal';

const UserEdit = (props: any) => {
    const { userId } = props?.data;
    const apiId = 'userConfig';
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);

    const [deviceModelData, setDeviceModelData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(getService('mf'),
            {
                query: {
                    apiId: 'deviceModel',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setDeviceModelData(res.data)
                }
            })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        primaryKeyName: 'userId',
        displayOptions: {
            width: 700
        },
        editMode: 'EDIT',
        editingId: userId,
        isAutoChangeMode: true,
        titleName: '用户配置',
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={12}>
                    <Form.Item
                        label="用户"
                        name="userId"
                        initialValue={userId}>
                        <Input disabled={true} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="关联设备型号"
                        name="deviceModelId"
                        tooltip='MQTT 关联设备型号id'>
                        <Select
                            placeholder="关联设备型号"
                            showSearch={{
                                optionFilterProp: 'children',
                                filterOption: (input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}>
                            {getList.general(deviceModelData, { itemName: 'modelName' })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={7}>
                    <Form.Item
                        label="必须关联设备"
                        name="isLinkedDeviceRequired"
                        valuePropName="checked"
                        tooltip='MQTT 设备客户端认证时，是否必须关联设备'>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

                <Col span={7}>
                    <Form.Item
                        label="自动关联设备"
                        name="isAutoLinkedDevice"
                        valuePropName="checked"
                        tooltip='MQTT 设备客户端认证时，是否自动关联设备'>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

            </Row >)
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default UserEdit;